export const LENS_PLUS_LEARN_MORE_LINK_URL =
    "https://developers.snap.com/lens-studio/Monetization/lens-creator-rewards/lens-plus-payouts";
export const TOP_PERFORMER_LEARN_MORE_LINK_URL =
    "https://developers.snap.com/lens-studio/Monetization/lens-creator-rewards/top-performer-payouts";
export const LENS_PLUS_APPLY_LINK_URL = "https://airtable.com/appKgGaXGsgyxLO1P/pagpw0QIF503cLAb9/form";
export const TOP_PERFOMER_TOS_URL = "https://snap.com/terms/lens-creator-rewards-terms";
export const LENS_PLUS_TOS_URL = "https://www.snap.com/terms/lens-payout";
export const PHONE_VERIFY_SUPPORT_URL =
    "https://help.snapchat.com/hc/en-us/articles/7012334341652-How-do-I-change-or-verify-my-mobile-number-on-Snapchat";
